import { Pipe, PipeTransform } from '@angular/core';
import {
	coerceCurrency,
	Currency,
	formatCurrencyAmount,
} from '@marmon/shared/types/common';

type CurrencyAmountOptions = {
	currency?: Currency | null;
	round?: boolean;
};

/**
 * Formats a major-unit amount (already converted out of cents) with a currency
 * symbol. Does not convert between currencies.
 */
@Pipe({
	name: 'currencyAmount',
	standalone: true,
})
export class CurrencyAmountPipe implements PipeTransform {
	transform(amount: number, options?: CurrencyAmountOptions) {
		return formatCurrencyAmount(
			amount ?? 0,
			coerceCurrency(options?.currency),
			{ round: options?.round },
		);
	}
}
